import {
    useAppRootStore,
    useModalsStore,
} from '@frontend/stores'
import {
    type ReactNode,
    useEffect,
} from 'react'
import {useLocation} from 'react-router-dom'
import {ScrollToTop} from 'swayok-react-mdb-ui-kit/components/ScrollToTop'

interface Props {
    children: ReactNode | ReactNode[]
    // Индикатор страницы логина или регистрации.
    authPage?: boolean
    // false (по умолчанию) - пересоздает компонент страницы, если location.key меняется (soft page reload).
    // true - компонент страницы не пересоздается при смене location.key.
    notReloadable?: boolean
    // CSS ID страницы.
    id?: string
}

// Публичные пути не требуют авторизации.
export function PublicRoute(props: Props) {

    const location = useLocation()

    const setAppSection = useAppRootStore(
        state => state.setAppSection
    )
    const hideModals = useModalsStore(
        state => state.hideModals
    )

    useEffect(() => {
        hideModals()
        setAppSection(props.authPage ? 'auth' : 'public')
    }, [])

    return (
        <main
            key={props.notReloadable ? '1' : (location.key ?? '1')}
            className="public-page-content"
            id={props.id}
        >
            <ScrollToTop key={location.pathname} />
            {props.children}
        </main>
    )
}
